import React from "react";
import axios from 'axios';



import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

import InputAdornment from '@mui/material/InputAdornment';



export default function PackingListExport () {


    const [value, setValue] = React.useState(null);

    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(null);

    const handleClick = () => {

        setLoading(true);
        setError(null);


        axios.post(`api/packing-lists/${value}/exporter/`, {}, { responseType: 'blob' })
            .then(function (response) {

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;

                const contentDisposition = response.headers['content-disposition'];

                const regex = new RegExp("filename[^;=\\n]*=['\"]?(?:UTF-\\d['\"]*)?([^;\\r\\n\"']*)['\"]?;?"); // https://stackoverflow.com/questions/23054475/javascript-regex-for-extracting-filename-from-content-disposition-header

                const match = regex.exec(contentDisposition);

                const filename = match[1]; // On prend le groupe 1

                link.setAttribute('download', decodeURIComponent(filename));

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

            })
            .catch((error) => {
                console.log(error);

                // 404 : le numéro n'existe pas. Tout autre échec (500) = la packing list
                // existe mais son PDF n'a pas pu être généré.
                const statut = error.response && error.response.status;

                setError(statut === 404
                    ? "Numéro invalide"
                    : "Erreur à la génération du PDF, veuillez contacter le support.");
            })
            .then(function () {
                // always executed
                setLoading(false);
                setValue(null);
            });

    }

    const handleKeyDown = (event) => {

        if (event.key === 'Enter' && value) {
            handleClick()
        }
    }



    return (
        <div style={{ paddingTop: '8px' }}>
            <TextField
                label="Réédition de packing list"
                color="secondary"
                InputProps={{
                    startAdornment: <InputAdornment position="start">#</InputAdornment>,
                    endAdornment: (
                        <InputAdornment position="end">
                            <Button
                                color="secondary"
                                onClick={handleClick}
                                disabled={loading || !value}
                                variant="contained"
                            >
                                Rééditer
                            </Button>
                        </InputAdornment>
                    ),
                }}
                type="number"
                inputProps={{ min: 1 }}
                disabled={loading}
                onChange={e => { setValue(e.target.value); setError(null); }}
                onKeyDown={handleKeyDown}
                variant="outlined"
                error={!!error}
                helperText={error || "Veuillez saisir un numéro de tracking list"}
            />                       

        </div>        
    );

}

